import * as React from 'react';

import DecimalInput from '~/UI/Input/DecimalInput';
import ERPPriceOriginDotMark from '../ERPPriceOriginDotMark';

interface ERPPriceVolumeGrowthPriceInputProps {
	userDefined: boolean;
	showEditing: boolean;
	value: number | string | null | undefined;
	onChange: (nextValue: string) => void;
	onEditingSet: React.Dispatch<React.SetStateAction<boolean>>;
	error?: boolean;
}

const ERPPriceVolumeGrowthPriceInput = ({
	showEditing,
	userDefined,
	value,
	onChange,
	onEditingSet,
	error,
}: ERPPriceVolumeGrowthPriceInputProps) => {
	const hasPrice = !(value == null || typeof value === 'undefined');
	const actualShow = showEditing || !hasPrice;

	return (
		<>
			<ERPPriceOriginDotMark price={value} userDefined={userDefined} />
			{actualShow ? (
				<DecimalInput
					allowEmpty
					selectOnFocus
					autoFocus={showEditing}
					className={`w-full px-1.5 py-1 font-display text-label text-black font-semibold leading-4 border ${
						error ? 'border-red-500' : 'border-gray-300'
					} rounded tabular-nums bg-white`}
					value={value || ''}
					onDecimalInput={(nextValue) => {
						onEditingSet(true);
						onChange(nextValue);
					}}
					hasError={error}
				/>
			) : (
				<span className='font-display text-label font-semibold text-gray-500 leading-none whitespace-nowrap'>
					{value}
				</span>
			)}
			{!actualShow && (
				<button
					className='grow w-full font-display text-labelsmall font-semibold text-cPurple-600 leading-none whitespace-nowrap text-right'
					type='button'
					onClick={() => onEditingSet(true)}
				>
					edit
				</button>
			)}
		</>
	);
};

export default React.memo(ERPPriceVolumeGrowthPriceInput);
